// ScrollHint.js — .scrollable に横スクロールヒント（AddQuicktag で囲む）

import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';

const CONFIG = {
  scrollableSelector: '.scrollable',
  iconAppendClass: 'scroll-hint-icon-newart',
};

function ScrollHintFunc() {
  const targets = document.querySelectorAll(CONFIG.scrollableSelector);
  if (targets.length === 0) return;

  new ScrollHint(targets, {
    scrollHintIconAppendClass: CONFIG.iconAppendClass,
    // アイコン画像に矢印が含まれるためテキストは出さない
    i18n: {
      scrollable: '',
    },
  });
}

export { ScrollHintFunc };
